import { useDateCountdown } from '@/hooks/helpers/useDateCountdown'

export function PollCountdown({ endDate }: { endDate: Date }) {
	const { days, hours, minutes, seconds } = useDateCountdown({ date: endDate })
	const formattedDate = [days, hours, minutes, seconds].map(x => x.toString().padStart(2, '0')).join(':')

	return <span className="text-[1.75rem] leading-none w-[10ch]">{formattedDate}</span>
}
